import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/student/version5/ai.png'
import _imports_1 from '@/assets/student/version5/white_close_icon.png'


import { IonModal } from "@ionic/vue";
import { ref } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'aiLoading',
  setup(__props, { expose: __expose }) {

const isOpen = ref(false);

function open() {
  isOpen.value = true;
}

function close() {
  isOpen.value = false;
}

__expose({
  isOpen,
  open,
  close,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), {
    id: "loading-modal",
    "is-open": isOpen.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", { class: "load" }, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "animation" }, [
          _createElementVNode("div", { class: "loading" }),
          _createElementVNode("img", {
            class: "ai-icon",
            src: _imports_0,
            alt: ""
          })
        ], -1)),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "loading-text" }, "AI正在生成中", -1)),
        _createElementVNode("img", {
          class: "load-icon",
          src: _imports_1,
          alt: "",
          onClick: close
        })
      ])
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

})